import { Button } from 'components/atoms';
import { PublicPage } from 'components/templates';
import { useCountdown, useResetPasswordNavigation } from 'hooks';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  PiCaretLeft,
  PiEnvelope,
  PiPaperPlaneTilt,
  PiTimer,
} from 'react-icons/pi';
import { useRequestResetPassword } from 'services/auth/resetPassword';
import { resetPasswordRequestValidationSchema } from '../request/ResetPasswordRequest';

const ResetPasswordRequestAgain = () => {
  const { t } = useTranslation();
  const { goToLogin, email } = useResetPasswordNavigation();
  const { countdown, isCountingDown, startCounter } = useCountdown(30);

  const requestPasswordReset = useRequestResetPassword();

  const onResetPasswordRequest = async () => {
    await requestPasswordReset.mutateAsync(
      { email },
      {
        onSuccess: startCounter,
        onError: goToLogin,
      }
    );
  };

  useEffect(() => {
    if (!resetPasswordRequestValidationSchema.isValidSync({ email })) {
      goToLogin();
    }
  }, [undefined, email]);

  return (
    <PublicPage
      header={
        <>
          <PiEnvelope />
          {t('reset-password-request-resend.header')}
        </>
      }
      footer={
        <div
          className='flex gap-2 cursor-pointer p-4 items-center'
          onClick={goToLogin}>
          <PiCaretLeft />
          {t('reset-password-request-resend.back')}
        </div>
      }>
      <div className='flex flex-col w-72 gap-4'>
        <p>
          <Trans
            i18nKey='reset-password-request-resend.message'
            values={{ email: email }}
            components={{ strong: <strong /> }}
          />
        </p>
        <p className='opacity-65 mt-10'>
          {t('reset-password-request-resend.message-not-arrived')}
        </p>
      </div>
      <Button
        onClick={onResetPasswordRequest}
        disabled={!!isCountingDown || !email.length}
        isLoading={requestPasswordReset.isPending}
        fullWidth>
        <Button.Text
          text={
            isCountingDown
              ? t('button.resend-timer', {
                  timer: countdown,
                })
              : t('button.resend')
          }
        />
        <Button.Icon
          icon={isCountingDown ? <PiTimer /> : <PiPaperPlaneTilt />}
        />
      </Button>
    </PublicPage>
  );
};

export default ResetPasswordRequestAgain;
